import { render, staticRenderFns } from "./SettingsSystemNotifications.vue?vue&type=template&id=49ee0996&scoped=true&"
import script from "./SettingsSystemNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingsSystemNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSystemNotifications.vue?vue&type=style&index=0&id=49ee0996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ee0996",
  null
  
)

export default component.exports